/**
 * GCS File Metadata Status Indicator
 * - The statuses available for a GCS file that is being processed
 */
export enum GCSFileMetadataStatusIndicator {
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR',
  DONE = 'DONE',
}

/**
 * GCS File Metadata Status Type
 * - For when a GCS file needs to determine its own processing status
 */
export type GCSFileMetadataStatus = {
  status: GCSFileMetadataStatusIndicator
  errorMessage?: string
}
